import { atom } from "recoil";
import { selector } from "./recoilSelectors";

/** Parts of the page that fold to a rail so the map keeps its room, e.g. while the job sheet is open. */
export type LayoutFolds = {
    /** the menu shows icons only */
    menu: boolean;
    /** the dispatch people list shows avatars only */
    members: boolean;
};

export const NO_FOLDS: LayoutFolds = { menu: false, members: false };

/** What the space budget would fold right now; set by the layout budget handler. */
export const layoutFoldsWantedState = atom<LayoutFolds>({
    key: "layout.folds.wanted",
    default: NO_FOLDS,
});

/** Folded parts the user opened again on purpose; they stay open until the layout changes. */
export const layoutUnfoldedState = atom<LayoutFolds>({
    key: "layout.folds.unfolded",
    default: NO_FOLDS,
});

export const layoutFoldsState = selector<LayoutFolds>({
    key: "layout.folds",
    get: ({ get }) => {
        const wanted = get(layoutFoldsWantedState);
        const unfolded = get(layoutUnfoldedState);
        return {
            menu: wanted.menu && !unfolded.menu,
            members: wanted.members && !unfolded.members,
        };
    },
});

/** How many pixels a Manage table gives up so an open sheet doesn't take them from the map; set by the layout budget handler. */
export const tableFoldState = atom<number>({
    key: "layout.folds.table",
    default: 0,
});

/** The folded people list shown over the route panel for a moment, without moving anything. */
export const memberRailPeekState = atom<boolean>({
    key: "layout.folds.members.peek",
    default: false,
});

/** The full people list fits beside the open route without pushing the map below its minimum. */
export const memberListFitsState = atom<boolean>({
    key: "layout.folds.members.fits",
    default: true,
});

/** True while a panel edge is dragged; the folds hold still until it is let go. */
export const panelsResizingState = atom<boolean>({
    key: "layout.panels.resizing",
    default: false,
});
